import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '“帮帮” 智能问答 带你玩转重庆';
const baseUrl = 'REPORT0426';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
